import { render } from "./HartenjagenGame.vue?vue&type=template&id=38532f02&scoped=true"
import script from "./HartenjagenGame.vue?vue&type=script&lang=js"
export * from "./HartenjagenGame.vue?vue&type=script&lang=js"

import "./HartenjagenGame.vue?vue&type=style&index=0&id=38532f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38532f02"]])

export default __exports__